export default /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows\sPhone/i.test(navigator.userAgent)